import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = ["aria-expanded"]
const _hoisted_4 = { class: "flex items-center gap-1.5 text-xs leading-[15px] font-normal tracking-[0.1px] text-parameter-text whitespace-nowrap" }
const _hoisted_5 = { class: "w-full" }
const _hoisted_6 = ["aria-expanded"]
const _hoisted_7 = { class: "flex items-center gap-1.5 text-xs leading-[15px] font-normal tracking-[0.1px] text-parameter-text whitespace-nowrap" }
const _hoisted_8 = { class: "w-full" }
const _hoisted_9 = ["aria-expanded"]
const _hoisted_10 = { class: "flex items-center gap-1.5 text-xs leading-[15px] font-normal tracking-[0.1px] text-parameter-text whitespace-nowrap" }
const _hoisted_11 = { class: "w-full" }
const _hoisted_12 = ["aria-expanded"]
const _hoisted_13 = { class: "flex items-center gap-1.5 text-xs leading-[15px] font-normal tracking-[0.1px] text-parameter-text whitespace-nowrap" }
const _hoisted_14 = { class: "w-full" }
const _hoisted_15 = ["aria-expanded"]
const _hoisted_16 = { class: "flex items-center gap-1.5 text-xs leading-[15px] font-normal tracking-[0.1px] text-parameter-text whitespace-nowrap" }
const _hoisted_17 = { class: "w-full" }
const _hoisted_18 = ["aria-expanded"]
const _hoisted_19 = { class: "flex items-center gap-1.5 text-xs leading-[15px] font-normal tracking-[0.1px] text-parameter-text whitespace-nowrap" }
const _hoisted_20 = { class: "w-full" }
const _hoisted_21 = ["aria-expanded"]
const _hoisted_22 = { class: "flex items-center gap-1.5 text-xs leading-[15px] font-normal tracking-[0.1px] text-parameter-text whitespace-nowrap" }
const _hoisted_23 = { class: "w-full flex divide-x divide-[#e7ddcc]" }
const _hoisted_24 = { class: "w-1/2 px-4 first:pl-0 last:pr-0" }
const _hoisted_25 = ["aria-expanded"]
const _hoisted_26 = { class: "flex items-center gap-1.5 text-xs leading-[15px] font-normal tracking-[0.1px] text-parameter-text whitespace-nowrap" }
const _hoisted_27 = { class: "w-1/2 px-4 first:pl-0 last:pr-0" }
const _hoisted_28 = ["aria-expanded"]
const _hoisted_29 = { class: "flex items-center gap-1.5 text-xs leading-[15px] font-normal tracking-[0.1px] text-parameter-text whitespace-nowrap" }

import ItemV3StonesStoneSize from "@/components/itemV3/parameter/stones/parameter/itemV3StonesStoneSize.vue";
import ItemV3StonesPosition from "@/components/itemV3/parameter/stones/parameter/itemV3StonesPosition.vue";
import {inject, reactive, ref} from "vue";
import ItemV3StonesForm from "@/components/itemV3/parameter/stones/parameter/itemV3StonesForm.vue";
import ItemV3StonesWaves from "@/components/itemV3/parameter/stones/parameter/itemV3StonesWaves.vue";
import ItemV3StonesSetting from "@/components/itemV3/parameter/stones/parameter/itemV3StonesSetting.vue";
import ItemV3StonesQuality from "@/components/itemV3/parameter/stones/parameter/itemV3StonesQuality.vue";
import ItemV3StonesNumber from "@/components/itemV3/parameter/stones/parameter/itemV3StonesNumber.vue";
import ItemV3StonesAddons from "@/components/itemV3/parameter/stones/parameter/itemV3StonesAddons.vue";
import ItemV3StonesPresets from "@/components/itemV3/parameter/stones/parameter/itemV3StonesPresets.vue";
import ItemV3StonesFormAngle from "@/components/itemV3/parameter/stones/parameter/itemV3StonesFormAngle.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'itemV3StonesGroupRows',
  props: {
    groupIdx: {}
  },
  emits: ["patch"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const loadItemVariants = inject<any>("loadItemVariants");

const itemIdx = inject<any>("itemIdx");
const session = inject<any>("session");

const focusSettings = [
  "BEZEL",
  "PAVE",
  "CHANNEL",
  "CROWN1"
]

const focusForm = [
  "ROUND",
  "PRINCESS",
  "BAGUETTE",
  "HEART",
  "OVAL",
  "MARQUISE",
  "PEAR",
  "TRIANGLE"
]

// only these stone_form_angle values (by idx) are shown; an empty list shows all
const focusFormAngle = [
  0,
  90
]

// shown via item-v3-stones-setting's "other" button, which emits "show-presets"
const showPresets = ref(false)

/**
 * headlines - collapsible sections (transferred from itemV3Grooves.vue's
 * "groove details - collapsible sections")
 */

const openSections = reactive<Record<string, boolean>>({
  waves: true,
  setting: true,
  addons: false,
  form: false,
  formAngle: false,
  number: false,
  quality: false,
  stone_size: false,
  position: false,
})

const toggleSection = (key: string) => {
  openSections[key] = !openSections[key]
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "flex w-full items-center gap-3 mb-3 cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#8b6536]",
        "aria-expanded": openSections.waves,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleSection('waves')))
      }, [
        _cache[22] || (_cache[22] = _createElementVNode("span", { class: "h-px flex-1 bg-[#e7ddcc]" }, null, -1)),
        _createElementVNode("span", _hoisted_4, [
          _cache[21] || (_cache[21] = _createTextVNode(" Verlauf ", -1)),
          (_openBlock(), _createElementBlock("svg", {
            "aria-hidden": "true",
            viewBox: "0 0 12 12",
            fill: "none",
            class: _normalizeClass(["size-2.5 shrink-0 text-[#555956] transition-transform", openSections.waves ? 'rotate-180' : ''])
          }, [...(_cache[20] || (_cache[20] = [
            _createElementVNode("path", {
              d: "m1.5 4 4.5 4 4.5-4",
              stroke: "currentColor",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, -1)
          ]))], 2))
        ]),
        _cache[23] || (_cache[23] = _createElementVNode("span", { class: "h-px flex-1 bg-[#e7ddcc]" }, null, -1))
      ], 8, _hoisted_3),
      (openSections.waves)
        ? (_openBlock(), _createBlock(ItemV3StonesWaves, {
            key: 0,
            class: "w-full",
            "group-idx": props.groupIdx,
            onPatch: _cache[1] || (_cache[1] = (event) => emit('patch', event))
          }, null, 8, ["group-idx"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        type: "button",
        class: "flex w-full items-center gap-3 mb-3 cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#8b6536]",
        "aria-expanded": openSections.setting,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleSection('setting')))
      }, [
        _cache[26] || (_cache[26] = _createElementVNode("span", { class: "h-px flex-1 bg-[#e7ddcc]" }, null, -1)),
        _createElementVNode("span", _hoisted_7, [
          _cache[25] || (_cache[25] = _createTextVNode(" Fassung ", -1)),
          (_openBlock(), _createElementBlock("svg", {
            "aria-hidden": "true",
            viewBox: "0 0 12 12",
            fill: "none",
            class: _normalizeClass(["size-2.5 shrink-0 text-[#555956] transition-transform", openSections.setting ? 'rotate-180' : ''])
          }, [...(_cache[24] || (_cache[24] = [
            _createElementVNode("path", {
              d: "m1.5 4 4.5 4 4.5-4",
              stroke: "currentColor",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, -1)
          ]))], 2))
        ]),
        _cache[27] || (_cache[27] = _createElementVNode("span", { class: "h-px flex-1 bg-[#e7ddcc]" }, null, -1))
      ], 8, _hoisted_6),
      (openSections.setting)
        ? (_openBlock(), _createBlock(ItemV3StonesSetting, {
            key: 0,
            class: "w-full",
            "prio-settings": focusSettings,
            "stone-layout": "row",
            "group-idx": props.groupIdx,
            onPatch: _cache[3] || (_cache[3] = (event) => emit('patch', event)),
            onShowPresets: _cache[4] || (_cache[4] = ($event: any) => (showPresets.value = !showPresets.value))
          }, null, 8, ["group-idx"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(ItemV3StonesPresets, {
      class: "w-full px-4",
      show: showPresets.value,
      "stone-layout": "row",
      onPatch: _cache[5] || (_cache[5] = (event) => emit('patch', event))
    }, null, 8, ["show"]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("button", {
        type: "button",
        class: "flex w-full items-center gap-3 mb-3 cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#8b6536]",
        "aria-expanded": openSections.addons,
        onClick: _cache[6] || (_cache[6] = ($event: any) => (toggleSection('addons')))
      }, [
        _cache[30] || (_cache[30] = _createElementVNode("span", { class: "h-px flex-1 bg-[#e7ddcc]" }, null, -1)),
        _createElementVNode("span", _hoisted_10, [
          _cache[29] || (_cache[29] = _createTextVNode(" Fassung-Varianten ", -1)),
          (_openBlock(), _createElementBlock("svg", {
            "aria-hidden": "true",
            viewBox: "0 0 12 12",
            fill: "none",
            class: _normalizeClass(["size-2.5 shrink-0 text-[#555956] transition-transform", openSections.addons ? 'rotate-180' : ''])
          }, [...(_cache[28] || (_cache[28] = [
            _createElementVNode("path", {
              d: "m1.5 4 4.5 4 4.5-4",
              stroke: "currentColor",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, -1)
          ]))], 2))
        ]),
        _cache[31] || (_cache[31] = _createElementVNode("span", { class: "h-px flex-1 bg-[#e7ddcc]" }, null, -1))
      ], 8, _hoisted_9),
      (openSections.addons)
        ? (_openBlock(), _createBlock(ItemV3StonesAddons, {
            key: 0,
            class: "w-full",
            "stone-layout": "row",
            "group-idx": props.groupIdx,
            onPatch: _cache[7] || (_cache[7] = (event) => emit('patch', event))
          }, null, 8, ["group-idx"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("button", {
        type: "button",
        class: "flex w-full items-center gap-3 mb-3 cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#8b6536]",
        "aria-expanded": openSections.form,
        onClick: _cache[8] || (_cache[8] = ($event: any) => (toggleSection('form')))
      }, [
        _cache[34] || (_cache[34] = _createElementVNode("span", { class: "h-px flex-1 bg-[#e7ddcc]" }, null, -1)),
        _createElementVNode("span", _hoisted_13, [
          _cache[33] || (_cache[33] = _createTextVNode(" Form ", -1)),
          (_openBlock(), _createElementBlock("svg", {
            "aria-hidden": "true",
            viewBox: "0 0 12 12",
            fill: "none",
            class: _normalizeClass(["size-2.5 shrink-0 text-[#555956] transition-transform", openSections.form ? 'rotate-180' : ''])
          }, [...(_cache[32] || (_cache[32] = [
            _createElementVNode("path", {
              d: "m1.5 4 4.5 4 4.5-4",
              stroke: "currentColor",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, -1)
          ]))], 2))
        ]),
        _cache[35] || (_cache[35] = _createElementVNode("span", { class: "h-px flex-1 bg-[#e7ddcc]" }, null, -1))
      ], 8, _hoisted_12),
      (openSections.form)
        ? (_openBlock(), _createBlock(ItemV3StonesForm, {
            key: 0,
            class: "w-full",
            "focus-form": focusForm,
            "group-idx": props.groupIdx,
            onPatch: _cache[9] || (_cache[9] = (event) => emit('patch', event))
          }, null, 8, ["group-idx"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("button", {
        type: "button",
        class: "flex w-full items-center gap-3 mb-3 cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#8b6536]",
        "aria-expanded": openSections.formAngle,
        onClick: _cache[10] || (_cache[10] = ($event: any) => (toggleSection('formAngle')))
      }, [
        _cache[38] || (_cache[38] = _createElementVNode("span", { class: "h-px flex-1 bg-[#e7ddcc]" }, null, -1)),
        _createElementVNode("span", _hoisted_16, [
          _cache[37] || (_cache[37] = _createTextVNode(" Steinwinkel ", -1)),
          (_openBlock(), _createElementBlock("svg", {
            "aria-hidden": "true",
            viewBox: "0 0 12 12",
            fill: "none",
            class: _normalizeClass(["size-2.5 shrink-0 text-[#555956] transition-transform", openSections.formAngle ? 'rotate-180' : ''])
          }, [...(_cache[36] || (_cache[36] = [
            _createElementVNode("path", {
              d: "m1.5 4 4.5 4 4.5-4",
              stroke: "currentColor",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, -1)
          ]))], 2))
        ]),
        _cache[39] || (_cache[39] = _createElementVNode("span", { class: "h-px flex-1 bg-[#e7ddcc]" }, null, -1))
      ], 8, _hoisted_15),
      (openSections.formAngle)
        ? (_openBlock(), _createBlock(ItemV3StonesFormAngle, {
            key: 0,
            class: "w-full",
            "prio-settings": focusFormAngle,
            "group-idx": props.groupIdx,
            onPatch: _cache[11] || (_cache[11] = (event) => emit('patch', event))
          }, null, 8, ["group-idx"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("button", {
        type: "button",
        class: "flex w-full items-center gap-3 mb-3 cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#8b6536]",
        "aria-expanded": openSections.number,
        onClick: _cache[12] || (_cache[12] = ($event: any) => (toggleSection('number')))
      }, [
        _cache[41] || (_cache[41] = _createElementVNode("span", { class: "h-px flex-1 bg-[#e7ddcc]" }, null, -1)),
        _createElementVNode("span", _hoisted_19, [
          _createTextVNode(_toDisplayString(_ctx.$t('components.parameters.stones.number.title')) + " ", 1),
          (_openBlock(), _createElementBlock("svg", {
            "aria-hidden": "true",
            viewBox: "0 0 12 12",
            fill: "none",
            class: _normalizeClass(["size-2.5 shrink-0 text-[#555956] transition-transform", openSections.number ? 'rotate-180' : ''])
          }, [...(_cache[40] || (_cache[40] = [
            _createElementVNode("path", {
              d: "m1.5 4 4.5 4 4.5-4",
              stroke: "currentColor",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, -1)
          ]))], 2))
        ]),
        _cache[42] || (_cache[42] = _createElementVNode("span", { class: "h-px flex-1 bg-[#e7ddcc]" }, null, -1))
      ], 8, _hoisted_18),
      (openSections.number)
        ? (_openBlock(), _createBlock(ItemV3StonesNumber, {
            key: 0,
            class: "w-full",
            "group-idx": props.groupIdx,
            onPatch: _cache[13] || (_cache[13] = (event) => emit('patch', event))
          }, null, 8, ["group-idx"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("button", {
        type: "button",
        class: "flex w-full items-center gap-3 mb-3 cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#8b6536]",
        "aria-expanded": openSections.quality,
        onClick: _cache[14] || (_cache[14] = ($event: any) => (toggleSection('quality')))
      }, [
        _cache[45] || (_cache[45] = _createElementVNode("span", { class: "h-px flex-1 bg-[#e7ddcc]" }, null, -1)),
        _createElementVNode("span", _hoisted_22, [
          _cache[44] || (_cache[44] = _createTextVNode(" Steinart/Qualität ", -1)),
          (_openBlock(), _createElementBlock("svg", {
            "aria-hidden": "true",
            viewBox: "0 0 12 12",
            fill: "none",
            class: _normalizeClass(["size-2.5 shrink-0 text-[#555956] transition-transform", openSections.quality ? 'rotate-180' : ''])
          }, [...(_cache[43] || (_cache[43] = [
            _createElementVNode("path", {
              d: "m1.5 4 4.5 4 4.5-4",
              stroke: "currentColor",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, -1)
          ]))], 2))
        ]),
        _cache[46] || (_cache[46] = _createElementVNode("span", { class: "h-px flex-1 bg-[#e7ddcc]" }, null, -1))
      ], 8, _hoisted_21),
      (openSections.quality)
        ? (_openBlock(), _createBlock(ItemV3StonesQuality, {
            key: 0,
            class: "w-full",
            "group-idx": props.groupIdx,
            onPatch: _cache[15] || (_cache[15] = (event) => emit('patch', event))
          }, null, 8, ["group-idx"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("button", {
          type: "button",
          class: "flex w-full items-center gap-3 mb-3 cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#8b6536]",
          "aria-expanded": openSections.stone_size,
          onClick: _cache[16] || (_cache[16] = ($event: any) => (toggleSection('stone_size')))
        }, [
          _cache[49] || (_cache[49] = _createElementVNode("span", { class: "h-px flex-1 bg-[#e7ddcc]" }, null, -1)),
          _createElementVNode("span", _hoisted_26, [
            _cache[48] || (_cache[48] = _createTextVNode(" Steingröße ", -1)),
            (_openBlock(), _createElementBlock("svg", {
              "aria-hidden": "true",
              viewBox: "0 0 12 12",
              fill: "none",
              class: _normalizeClass(["size-2.5 shrink-0 text-[#555956] transition-transform", openSections.stone_size ? 'rotate-180' : ''])
            }, [...(_cache[47] || (_cache[47] = [
              _createElementVNode("path", {
                d: "m1.5 4 4.5 4 4.5-4",
                stroke: "currentColor",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, null, -1)
            ]))], 2))
          ]),
          _cache[50] || (_cache[50] = _createElementVNode("span", { class: "h-px flex-1 bg-[#e7ddcc]" }, null, -1))
        ], 8, _hoisted_25),
        (openSections.stone_size)
          ? (_openBlock(), _createBlock(ItemV3StonesStoneSize, {
              key: 0,
              class: "w-full",
              "group-idx": props.groupIdx,
              onPatch: _cache[17] || (_cache[17] = (event) => emit('patch', event))
            }, null, 8, ["group-idx"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("button", {
          type: "button",
          class: "flex w-full items-center gap-3 mb-3 cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#8b6536]",
          "aria-expanded": openSections.position,
          onClick: _cache[18] || (_cache[18] = ($event: any) => (toggleSection('position')))
        }, [
          _cache[53] || (_cache[53] = _createElementVNode("span", { class: "h-px flex-1 bg-[#e7ddcc]" }, null, -1)),
          _createElementVNode("span", _hoisted_29, [
            _cache[52] || (_cache[52] = _createTextVNode(" Position ", -1)),
            (_openBlock(), _createElementBlock("svg", {
              "aria-hidden": "true",
              viewBox: "0 0 12 12",
              fill: "none",
              class: _normalizeClass(["size-2.5 shrink-0 text-[#555956] transition-transform", openSections.position ? 'rotate-180' : ''])
            }, [...(_cache[51] || (_cache[51] = [
              _createElementVNode("path", {
                d: "m1.5 4 4.5 4 4.5-4",
                stroke: "currentColor",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, null, -1)
            ]))], 2))
          ]),
          _cache[54] || (_cache[54] = _createElementVNode("span", { class: "h-px flex-1 bg-[#e7ddcc]" }, null, -1))
        ], 8, _hoisted_28),
        (openSections.position)
          ? (_openBlock(), _createBlock(ItemV3StonesPosition, {
              key: 0,
              class: "w-full",
              "group-idx": props.groupIdx,
              onPatch: _cache[19] || (_cache[19] = (event) => emit('patch', event))
            }, null, 8, ["group-idx"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})